// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2wY09","head":"ProcedureTableInfo_head__3a_lh"};